export const STATUSES = [
    { id: 'AUTO', label: 'Auto (from times)', code: '', consumesConge: 0, consumesRecup: 0 },
    { id: 'CONGE', label: 'Congé', code: 'C', consumesConge: 1, consumesRecup: 0 },
    { id: 'CONGE_HALF', label: '½ Congé', code: '½C', consumesConge: 0.5, consumesRecup: 0 },
    { id: 'SICK', label: 'Maladie (M)', code: 'M', consumesConge: 0, consumesRecup: 0 },
    { id: 'SICK_PAID', label: 'Congé maladie (CM)', code: 'CM', consumesConge: 0, consumesRecup: 0 },
    { id: 'REMOTE', label: 'Télétravail (TT)', code: 'T', consumesConge: 0, consumesRecup: 0 },
    { id: 'RECUP', label: 'Récup', code: 'R', consumesConge: 0, consumesRecup: 1 },
    { id: 'ABSENT', label: 'Absent', code: 'A', consumesConge: 0, consumesRecup: 0 },
    { id: 'HOLIDAY', label: 'Férié', code: 'F', consumesConge: 0, consumesRecup: 0 },
];
export const STATUS_BY_ID = Object.fromEntries(STATUSES.map((s) => [s.id, s]));
// « Absence injustifiée » — seeded CustomDecisionType, referenced by code
// on AttendanceRecord.decisionCustomCode. It is the one custom type the
// engine knows by name: it re-qualifies a day as unjustified (cell anj,
// 0 h paie) instead of the justified default every other custom gets.
export const ABSENCE_INJUSTIFIEE_CODE = 'ABSENCE_INJUSTIFIEE';
//# sourceMappingURL=statuses.js.map